// Used to hold the text message inside the message wrapper
import React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;

const TextMessage = ({ message }) => {
  return <Text className="text-[#616874] text-xs">{message}</Text>;
};

export default TextMessage;
